import MessageBox from './src/messageBox.js'
export default MessageBox



// WEBPACK FOOTER //
// ./src/packages/message-box/index.js